if (!window.Eurus || !window.Eurus.loadedScript) {
  window.Eurus = window.Eurus || {};
  window.Eurus.loadedScript = window.Eurus.loadedScript || new Set();
}

if (!window.Eurus.loadedScript.has('sticky-atc-recharge.js')) {
  window.Eurus.loadedScript.add('sticky-atc-recharge.js');

  // Initialize observers array for cleanup
  window.Eurus.rechargeObservers = window.Eurus.rechargeObservers || [];

  // Initialize retry counter for widget detection
  window.Eurus.rechargeRetryCount = 0;
  window.Eurus.rechargeMaxRetries = 20; // Max 10 seconds (20 * 500ms)

  // Initialize or reset selling plan tracking
  if (!window.selectedSellingPlan) {
    window.selectedSellingPlan = {
      isSubscription: false,
      frequency: ''
    };
  }

  // Store original price for subscription price updates
  // Reset on script load to prevent stale values across page navigations
  if (!window.Eurus.hasOwnProperty('originalPrice')) {
    window.Eurus.originalPrice = null;
  }

  if (!window.Eurus.hasOwnProperty('subscriptionDiscount')) {
    window.Eurus.subscriptionDiscount = 0.20; // 20% discount
  }

  // Reset price tracking when navigating to a new product
  const resetPriceTracking = () => {
    window.Eurus.originalPrice = null;
  };

  // Reset on page load (compatible with all browsers)
  if (document.readyState === 'loading' || document.readyState === 'interactive') {
    resetPriceTracking();
  }

  // Cleanup function for observers
  function cleanupObservers() {
    if (window.Eurus.rechargeObservers && window.Eurus.rechargeObservers.length > 0) {
      window.Eurus.rechargeObservers.forEach(observer => {
        if (observer && typeof observer.disconnect === 'function') {
          observer.disconnect();
        }
      });
      window.Eurus.rechargeObservers = [];
    }
    // Clear the observed elements tracking on cleanup
    if (window.Eurus.observedTitleElements) {
      window.Eurus.observedTitleElements = new WeakSet();
    }
  }

  function updateStickyATCWithSellingPlan() {

    const stickyTitleElements = document.querySelectorAll('[id^="product-title-sticky-"]');

    stickyTitleElements.forEach(element => {
      const paragraph = element.querySelector('p');
      if (!paragraph) {
        return;
      }

      let currentText = paragraph.textContent.trim();

      currentText = currentText.replace(/\s*-\s*\d+\s*weeks?$/i, '');

      if (window.selectedSellingPlan && window.selectedSellingPlan.isSubscription && window.selectedSellingPlan.frequency) {
        currentText += ' - ' + window.selectedSellingPlan.frequency;
      }

      paragraph.textContent = currentText;
    });
  }

  window.updateStickyATCWithSellingPlan = updateStickyATCWithSellingPlan;

  function updatePriceDisplay(isSubscription) {
    const targetPriceEl = document.querySelector('.target-price');

    if (!targetPriceEl) {
      return;
    }

    const currentPrice = parseInt(targetPriceEl.textContent.trim());

    // Check if we need to update the stored original price
    if (window.Eurus.originalPrice !== null) {
      const expectedDiscountedPrice = Math.floor(window.Eurus.originalPrice * (1 - window.Eurus.subscriptionDiscount));

      // If current price doesn't match either original or discounted price,
      // it means variant changed and Shopify updated the price
      // So we need to update our stored original price
      if (currentPrice !== window.Eurus.originalPrice && currentPrice !== expectedDiscountedPrice) {
        window.Eurus.originalPrice = currentPrice;
      }
    } else {
      // Store original price on first run
      if (!isNaN(currentPrice) && currentPrice > 0) {
        window.Eurus.originalPrice = currentPrice;
      }
    }

    if (window.Eurus.originalPrice === null) {
      return;
    }

    let newPrice;
    if (isSubscription) {
      // Apply 20% discount
      newPrice = Math.floor(window.Eurus.originalPrice * (1 - window.Eurus.subscriptionDiscount));
    } else {
      // Restore original price
      newPrice = window.Eurus.originalPrice;
    }

    // Only update if the price actually changed
    if (currentPrice !== newPrice) {
      // Update the hidden price element (this will trigger rewards points recalculation)
      targetPriceEl.textContent = newPrice;

      // Update the visible price display
      updateVisiblePrice(newPrice);

      // Dispatch event to notify other scripts of price change
      const event = new CustomEvent('variant:changed', {
        detail: { price: newPrice, isSubscription: isSubscription }
      });
      document.dispatchEvent(event);
    }
  }

  function updateVisiblePrice(priceInCents) {
    // Format price as money
    const priceInDollars = (priceInCents / 100).toFixed(2);
    const formattedPrice = '$' + priceInDollars;

    // Update main product price
    const mainPriceContainer = document.querySelector('.main-product-price');
    if (mainPriceContainer) {
      const mainPriceElement = mainPriceContainer.querySelector('p.price > span:first-child, .price-sale');
      if (mainPriceElement) {
        mainPriceElement.textContent = formattedPrice;
      }
    }

    // Update sticky add-to-cart prices
    const stickyPriceContainers = document.querySelectorAll('[id^="price-sticky-"], .price-sticky');
    stickyPriceContainers.forEach(container => {
      const stickyPriceElement = container.querySelector('p.price > span:first-child, .price-sale, span:not(.stamped-io-rewards-points)');
      if (stickyPriceElement && !stickyPriceElement.closest('.stamped-io-rewards-points')) {
        stickyPriceElement.textContent = formattedPrice;
      }
    });
  }

  function getRechargeSellingPlan() {
    const rechargeWidget = document.querySelector('recharge-subscription-widget');

    if (!rechargeWidget) {
      return null;
    }

    if (!rechargeWidget.shadowRoot) {
      return null;
    }


    try {
      const shadowRoot = rechargeWidget.shadowRoot;

      const subscriptionRadio = shadowRoot.querySelector('input[type="radio"][value="subscription"]');

      const isSubscriptionSelected = subscriptionRadio && subscriptionRadio.checked;

      if (!isSubscriptionSelected) {
        return {
          isSubscription: false,
          frequency: ''
        };
      }

      let frequency = '';

      let selects = shadowRoot.querySelectorAll('select');

      if (selects.length === 0) {
        const rcSellingPlans = shadowRoot.querySelector('rc-selling-plans');
        if (rcSellingPlans && rcSellingPlans.shadowRoot) {
          selects = rcSellingPlans.shadowRoot.querySelectorAll('select');
        }
      }

      for (const select of selects) {
        if (select.value && select.options && select.selectedIndex >= 0) {
          const selectedOption = select.options[select.selectedIndex];
          const optionText = selectedOption.textContent.trim();
          if (optionText.match(/\d+\s*weeks?/i)) {
            frequency = optionText;
            break;
          }
        }
      }

      if (!frequency) {
        const selectedRadio = shadowRoot.querySelector('input[type="radio"]:checked:not([value="subscription"]):not([value="onetime"])');

        if (selectedRadio) {
          const label = shadowRoot.querySelector(`label[for="${selectedRadio.id}"]`);
          if (label) {
            const labelText = label.textContent.trim();
            if (labelText.match(/\d+\s*weeks?/i)) {
              frequency = labelText;
            }
          }
          if (!frequency && selectedRadio.value.match(/\d+\s*weeks?/i)) {
            frequency = selectedRadio.value;
          }
        }
      }

      if (!frequency) {
        const allElements = shadowRoot.querySelectorAll('*');
        for (const el of allElements) {
          const style = window.getComputedStyle(el);
          if (style.display === 'none' || style.visibility === 'hidden') continue;

          const text = el.textContent.trim();
          if (text.match(/^\d+\s*weeks?$/i)) {
            frequency = text;
            break;
          }
        }
      }

      if (!frequency) {
        const frequencyText = shadowRoot.querySelector('[class*="selected"] [class*="frequency"]');
        if (frequencyText) {
          const match = frequencyText.textContent.match(/\d+\s*weeks?/i);
          if (match) {
            frequency = match[0];
          }
        }
      }


      return {
        isSubscription: true,
        frequency: frequency
      };
    } catch (error) {
      console.error('[Recharge Sticky ATC] Error reading Recharge widget:', error);
      return null;
    }
  }

  function initRechargeObserver() {
    const rechargeWidget = document.querySelector('recharge-subscription-widget');

    if (!rechargeWidget) {
      // Prevent infinite loop by limiting retries
      if (window.Eurus.rechargeRetryCount < window.Eurus.rechargeMaxRetries) {
        window.Eurus.rechargeRetryCount++;
        setTimeout(initRechargeObserver, 500);
      } else {
        console.warn('[Recharge Sticky ATC] Widget not found after maximum retries. Stopping initialization.');
      }
      return;
    }


    const checkSellingPlan = () => {
      const sellingPlan = getRechargeSellingPlan();

      if (sellingPlan && window.selectedSellingPlan) {
        const hasChanged =
          window.selectedSellingPlan.isSubscription !== sellingPlan.isSubscription ||
          window.selectedSellingPlan.frequency !== sellingPlan.frequency;

        if (hasChanged) {
          window.selectedSellingPlan = sellingPlan;
          updateStickyATCWithSellingPlan();
          updatePriceDisplay(sellingPlan.isSubscription);
        }
      }
    };

    if (rechargeWidget.shadowRoot) {
      // Clean up any existing observers before creating new ones
      cleanupObservers();

      const shadowObserver = new MutationObserver(() => {
        checkSellingPlan();
      });

      // Store observer for cleanup
      window.Eurus.rechargeObservers.push(shadowObserver);

      shadowObserver.observe(rechargeWidget.shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['checked', 'selected', 'value']
      });

      setTimeout(() => {
        if (rechargeWidget.shadowRoot) {
          rechargeWidget.shadowRoot.addEventListener('change', () => {
            checkSellingPlan();
          });
          rechargeWidget.shadowRoot.addEventListener('click', () => {
            setTimeout(checkSellingPlan, 100);
          });

          const rcSellingPlans = rechargeWidget.shadowRoot.querySelector('rc-selling-plans');
          if (rcSellingPlans && rcSellingPlans.shadowRoot) {

            rcSellingPlans.shadowRoot.addEventListener('change', () => {
              checkSellingPlan();
            });

            const nestedObserver = new MutationObserver(() => {
              checkSellingPlan();
            });

            // Store nested observer for cleanup
            window.Eurus.rechargeObservers.push(nestedObserver);

            nestedObserver.observe(rcSellingPlans.shadowRoot, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['checked', 'selected', 'value']
            });
          }
        }
      }, 500);
    }

    checkSellingPlan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initRechargeObserver();
    });
  } else {
    initRechargeObserver();
  }

  document.addEventListener('eurus:product-page-variant-select:updated', (e) => {
    setTimeout(() => {
      // Capture the new variant's base price from the updated .target-price element
      const targetPriceEl = document.querySelector('.target-price');
      if (targetPriceEl) {
        const newVariantPrice = parseInt(targetPriceEl.textContent.trim());
        if (!isNaN(newVariantPrice) && newVariantPrice > 0) {
          // Always update to the new variant's price
          window.Eurus.originalPrice = newVariantPrice;
        }
      }

      updateStickyATCWithSellingPlan();
      // Re-apply subscription discount if currently selected
      if (window.selectedSellingPlan && window.selectedSellingPlan.isSubscription) {
        updatePriceDisplay(true);
      }
    }, 200); // Increased timeout to ensure Shopify updates price first
  });

  // Track which elements already have observers
  window.Eurus.observedTitleElements = window.Eurus.observedTitleElements || new WeakSet();

  const observeStickyTitleChanges = () => {
    const stickyTitleElements = document.querySelectorAll('[id^="product-title-sticky-"]');

    stickyTitleElements.forEach((element, index) => {
      // Skip if element already has an observer
      if (window.Eurus.observedTitleElements.has(element)) {
        return;
      }

      const titleObserver = new MutationObserver(() => {
        setTimeout(() => {
          updateStickyATCWithSellingPlan();
        }, 50);
      });

      // Store title observer for cleanup
      window.Eurus.rechargeObservers.push(titleObserver);

      // Mark element as observed
      window.Eurus.observedTitleElements.add(element);

      titleObserver.observe(element, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  };

  // Add cleanup on page unload/navigation
  window.addEventListener('beforeunload', cleanupObservers);
  window.addEventListener('pagehide', cleanupObservers);

  setTimeout(() => {
    observeStickyTitleChanges();
  }, 1000);
}
